// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mini-footer-layout{\n  background-color:#354c6d;\n  box-sizing:border-box\n}\n.mini-footer-layout__link{\n  color:#8094b0;\n  font-size:10px;\n  margin-left:10px\n}\n.mini-footer-layout__logo{\n  height:17px\n}\n.link-0{\n  margin-left:0!important\n}\n@media screen and (min-width:768px) and (max-width:1023px){\n.links-container{\n    max-width:350px\n}\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
